import { usePurchaseButtonContext } from './Context'
import { useAddPurchaseOrderByVendor } from '@ztechapps/purchase-order.common'
import { HorizontalStack, ShowIf } from '@ztechapps/webui.util'
import { Stack } from 'react-bootstrap'
import { BusyButton } from '@ztechapps/webui.button'
import React from 'react'
import type { VendorSelectProps } from '@ztechapps/webui.contract'
import { useInjectComponent, WebuiIocKey } from '@ztechapps/webui.contract'

export const NewPurchaseOrder = () => {
  const VendorSelect = useInjectComponent<VendorSelectProps>(WebuiIocKey.vendor.vendorSelect)
  const {
    product,
    vendor,
    qtyNeededToBuild,
    actionType,
    setVendor,
    truncatedProductName,
    useErrorResult,
    setPurchaseOrderResult,
    setShowConfirm,
  } = usePurchaseButtonContext()
  const { onError } = useErrorResult

  const [onAdd, { loading }] = useAddPurchaseOrderByVendor()

  const handleAddNew = async () => {
    try {
      const result = await onAdd({
        vendorId: vendor?._id,
        quantity: qtyNeededToBuild,
        productId: product._id,
        price: 0,
        vendorCode: '',
      })
      setPurchaseOrderResult(result?.data?.createPurchaseOrder)
    } catch (e) {
      onError(e)
    } finally {
      //error or not, show the confirm
      setShowConfirm(true)
    }
  }

  return (
    <ShowIf condition={actionType === 'add-new'}>
      <Stack gap={2}>
        <HorizontalStack>
          <div className="flex-grow-1">
            <VendorSelect
              disabled={loading}
              showInfo={true}
              value={vendor as any}
              onChange={(e) => setVendor(e as unknown as any)}
              placeholder="Choose a vendor for the new purchase order"
            />
          </div>
        </HorizontalStack>
        <BusyButton
          onClick={handleAddNew}
          text={`Add "${truncatedProductName}" to new purchase order`}
          icon="plus"
          isBusy={loading}
          disabled={!vendor}
        />
      </Stack>
    </ShowIf>
  )
}
